import { createClient, OASClient, type NormalizeOAS } from 'fets';
import type openapi from './aiOpenApi';
import { AuthPlugin } from './fetsAuthPlugin';

export type AiFetsApiClient = OASClient<NormalizeOAS<typeof openapi>>;

export const createAiFetsClient = (
  backendUrl: string,
  provideAuthTokenFunc: () => Promise<string>
): AiFetsApiClient => {
  const apiClient = createClient<NormalizeOAS<typeof openapi>>({
    endpoint: backendUrl,
    plugins: [AuthPlugin(provideAuthTokenFunc)],
  });

  return apiClient;
};
